import { useState } from "react";
var useInputType = function (defaultValue) {
    if (defaultValue === void 0) { defaultValue = "password"; }
    var _a = useState(defaultValue), type = _a[0], setType = _a[1];
    var inputValue = type === "password" ? "show" : "hide";
    var changeType = function (newType) {
        setType(function (prevType) {
            if (newType)
                return newType;
            switch (prevType) {
                case "password":
                    return "text";
                case "text":
                    return "password";
            }
        });
    };
    return [type, changeType, inputValue];
};
export default useInputType;
